import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, parsePrinterXML } from '../../helpers';
import URLSearchParams from '@ungap/url-search-params';
import moment from 'moment';
import { DateUtils } from 'react-day-picker';
import Message from '../Common/Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SearchEvents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            keyword: '',
            message: {
                title: '',
                content: '',
                type: ''
            },
            events: [],
            flexpasses: [],
        }
    }

    switchUser = (client_id) => {

        this.props.switchUser(client_id);
    }

    setKeyword = (value) => {
        let keyword = {...this.state.keyword};
        keyword = value;
        this.setState({ keyword });
    }

    handleChange = (e) => {
        this.setKeyword(e.target.value);
    }

    submitSearch = () => {
        const keyword = this.state.keyword;
        const doPost = async (keyword) => {
            try {
                const searchResponse = await search(keyword);
                console.log('Search response: ', searchResponse);

                this.setState({
                    events: searchResponse.data.events,
                    flexpasses: searchResponse.data.flexpasses,
                });
                this.setMessage('', '', '');
                
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        }

        async function search(keyword) {
            return await ApiRequest(`/admin/events/search?search=${keyword}`, {
                method: 'GET',
            });
        }

        this.setMessage('', '', 'loading');
        doPost(keyword);
    }

    handleKeyUp = (e) => {
        if(e.keyCode === 13){
            this.submitSearch();
        }
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    renderEvents = () => {
        if (this.state.events.length > 0) {
            return (
                <React.Fragment>
                    <h2>Events</h2>
                    <div className="x_table-responsive">
                        <table className="showtix-table showtix-table__striped">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Client</th>
                                    <th>Venue</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.events.map((event) => (
                                    <tr>
                                        <td>
                                            {event.poster_graphic_url && (
                                                <img width="70" src={event.poster_graphic_url} />
                                            )}
                                            {event.event_name}
                                        </td>
                                        <td>
                                            <a href="#" onClick={() => this.switchUser(event.client_id)}>
                                                {event.client_name}
                                            </a>
                                        </td>
                                        <td>
                                            {event.venue_name}<br />
                                            {event.city}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            );
        }
    };

    renderFlexpasses = () => {
        if (this.state.flexpasses.length > 0) {
            return (
                <React.Fragment>
                    <h2>Flexpasses</h2>
                    <div className="x_table-responsive">
                        <table className="showtix-table showtix-table__striped">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Client</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.flexpasses.map((flexpass) => (
                                    <tr>
                                        <td>
                                            {flexpass.poster_graphic_url && (
                                                <img width="70" src={flexpass.poster_graphic_url} />
                                            )}
                                            {flexpass.flexpass_name}
                                        </td>
                                        <td>
                                            {flexpass.client_name}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            );
        }
    };

    render() {
        return (
            <div>
                <div className="showtix-search">
                    <div className="showtix-section container">
                        <div className="row">
                            <div className="col-12">
                                <h1>{strings.title}</h1>
                            </div>
                        </div>

                        <div className="row showtix-search__form">
                            <div className="col-12 col-lg-9">
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="keyword">
                                                {strings.searchLabel}
                                            </label>
                                            <div className="showtix-form__input">
                                                <input
                                                    id="keyword"
                                                    className="showtix-input"
                                                    type="text"
                                                    name="keyword"
                                                    onChange={this.handleChange}
                                                    onKeyUp={this.handleKeyUp}
                                                    value={this.state.keyword || ''}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <button
                                            className="showtix-button showtix-background__primary-1"
                                            onClick={this.submitSearch}
                                        >{strings.searchBtn}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr className="color-1" />
                        
                    </div>
                </div>
                
                <div className="container">
                    <Message 
                        message={this.state.message}
                    />

                    {this.renderEvents()}
                    {this.renderFlexpasses()}
                    

                </div>
            </div>
        )
    }
}

export default SearchEvents;



// WEBPACK FOOTER //
// ./src/components/SearchEvents/SearchEvents.js